import {RequestMessage} from '@crealogix-map/core';

export const openExternalPageMessageTag = 'OpenExternalPageMessage';

/**
 * Request the browser to close itself. Only browsers which are allowing the close button will be closed by this message.
 */
export class OpenExternalPageMessage extends RequestMessage {
  readonly tag: string = openExternalPageMessageTag;

  constructor(url: string) {
    super();

    this.url = url;
  }

  /**
   * The url to be opened.
   */
  url: string;
}



// WEBPACK FOOTER //
// /Users/zasa/map/map-core-git/~/tslint-loader??ref--0-1!./src/Browser/OpenExternalPageMessage.ts